// Test page to preview all 3 creatures statically (dev only)
import CartoonCrab from "@/components/creatures/CartoonCrab";
import CartoonTurtle from "@/components/creatures/CartoonTurtle";
import CartoonSeagull from "@/components/creatures/CartoonSeagull";

export default function CreaturePreview() {
  return (
    <div className="min-h-screen bg-[#FAFAF9] p-12">
      <h1 className="font-serif-display text-4xl mb-10">Creatures preview</h1>
      <div className="grid grid-cols-3 gap-8 max-w-5xl">
        <div className="bg-white border p-8 flex flex-col items-center"><CartoonCrab className="w-48 h-40" /><p className="mt-4 text-sm">Lalo (azul)</p></div>
        <div className="bg-white border p-8 flex flex-col items-center"><CartoonTurtle className="w-56 h-44" /><p className="mt-4 text-sm">Tati</p></div>
        <div className="bg-white border p-8 flex flex-col items-center"><CartoonSeagull className="w-48 h-40" /><p className="mt-4 text-sm">Vita</p></div>
      </div>
    </div>
  );
}
